// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function removeLeadingZeros(string: any): string {
  return typeof string === "number" || typeof string === "string" ? String(string).replace(/\b0+/g, "") : "";
}
